import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d5eb0c4")

_pushScopeId("data-v-3d5eb0c4")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "signup-div" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "main-heading" }, " &MEMBERSHIP", -1)
const _hoisted_4 = { class: "signup-response" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createVNode("h1", { class: "heading-response error" }, "ERROR!", -1)
const _hoisted_7 = { class: "message" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("START OVER")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_ctx.query)
    ? (_openBlock(), _createBlock(_component_ion_page, { key: 0 }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_ion_icon, {
                class: "membership-icon",
                icon: "/assets/icons/Asset_1.svg"
              }),
              _hoisted_3
            ]),
            _createVNode("div", _hoisted_4, [
              (!_ctx.success)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode("p", _hoisted_7, _toDisplayString(_ctx.query?.error), 1)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("h1", {
                      class: ["heading-response", {error: !_ctx.success}],
                      innerHTML: _ctx.heading
                    }, null, 10, ["innerHTML"]),
                    (_ctx.message)
                      ? (_openBlock(), _createBlock("p", {
                          key: 0,
                          class: "message",
                          innerHTML: _ctx.message
                        }, null, 8, ["innerHTML"]))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _createVNode(_component_ion_button, {
              href: "/loyalty/guest",
              routerDirection: "backward",
              class: "start-over-btn",
              size: "large",
              fill: "solid",
              type: "submit",
              expand: "block"
            }, {
              default: _withId(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
})